package top.wcpe.allincore.dsl.ir.model

/**
 * Phase 3：intercept 路由规则 IR 节点。
 *
 * 声明在 screen 的 IR 顶层，定义该页面的拦截条件。
 *
 *  - `screenId` — 页面 id（如 "settings/main"）
 *  - `menuType` — 匹配的 menuType（如 "options"、"minecraft:generic_9x54"）
 *  - `conditionBytes` — 条件表达式字节码（可空，空 = 无条件匹配）
 */
class UiInterceptRule(screenId: String, menuType: String, conditionBytes: ByteArray?) {

    // val 属性生成 getScreenId()/getMenuType()，与原 Java getter 名一致。
    val screenId: String = requireNotNull(screenId) { "screenId" }
    val menuType: String = requireNotNull(menuType) { "menuType" }

    // 防御式拷贝：构造时复制入参数组。
    private val conditionBytesInternal: ByteArray? = conditionBytes?.copyOf()

    val conditionBytes: ByteArray?
        get() = conditionBytesInternal?.copyOf()

    /** 是否有条件表达式（false = 无条件匹配）。 */
    fun hasCondition(): Boolean = conditionBytesInternal != null && conditionBytesInternal.isNotEmpty()

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is UiInterceptRule) return false
        return screenId == other.screenId &&
            menuType == other.menuType &&
            conditionBytesInternal.contentEquals(other.conditionBytesInternal)
    }

    // 逐位复刻：先 Objects.hash(screenId, menuType)（种子 1、31 倍累乘），
    // 再 31*result + Arrays.hashCode(conditionBytes)。
    override fun hashCode(): Int {
        var result = 1
        result = 31 * result + screenId.hashCode()
        result = 31 * result + menuType.hashCode()
        result = 31 * result + conditionBytesInternal.contentHashCode()
        return result
    }

    override fun toString(): String =
        "UiInterceptRule{screenId='" + screenId + "', menuType='" + menuType +
            "', hasCondition=" + hasCondition() + "}"
}
